import { PlanetMediaPlayerEvents, PlanetMediaPlayerSetup } from '../models';
import { PluginConfiguration } from '../plugin';
import { BaseMediaController } from './base-media-controller';

export abstract class PlanetMediaPlayer extends BaseMediaController {

    protected constructor(containerId: string, plugins: PluginConfiguration[] = []) {
        super(containerId, plugins);
    }

    async setup(config: PlanetMediaPlayerSetup): Promise<void> {
        this.emit(PlanetMediaPlayerEvents.BeforeSetup);
        await super.setup(config);
    }
}
